
import cloneDeep from 'lodash/cloneDeep'

export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-search-cp',
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      filteredOptions: [],
      optionSelected: {
        cp: '',
        claveEntidadFederativa: null,
        claveMunicipio: null,
        municipio: '',
        entidadFederativa: '',
        colonia: '',
        calle: null,
        numeroInterior: '',
        numeroExterior: '',
        entreCalle1: '',
        yCalle2: '',
        referenciasAdicionales: '',
        customSuburb: false,
      },
      searchQuery: '',
      loading: false,
      numberRule: [
        (v) => !v || /^-?\d*\.?\d+$/.test(v) || this.$t('invalidNumber'),
      ],
      errorMessage: '',
      rules: [(v) => !!v || this.$t('fieldRequired')],
    }
  },
  async fetch() {},
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.searchQuery = val.cp
        this.optionSelected = cloneDeep(val)
        this.optionSelected.customSuburb = val.customSuburb
      }
    },
    searchQuery(val) {
      if (!val) {
        this.clearData()
      }
    },
  },
  mounted() {
    if (this.value) {
      this.searchQuery = this.value.cp
      this.optionSelected = Object.assign({}, this.value)
      this.optionSelected.customSuburb = this.value.customSuburb
      if (this.searchQuery && !this.optionSelected.customSuburb) {
        this.getCpData()
      }
    }
  },
  methods: {
    onInputUppercase(field, val) {
      // Revisamos si el campo es de solo mayusculas, si lo es mandamos el evento
      // para el cambio
      if (this.obj.schema.onlyMayus) {
        this.optionSelected[field] = val.toUpperCase()
      }
    },
    setCustomSuburb(value) {
      if (value) {
        this.optionSelected.colonia = ''
        this.$emit('input', null)
      }
      this.optionSelected.customSuburb = value
      if (this.searchQuery && !value) {
        this.getCpData()
      }
    },
    clearData() {
      this.searchQuery = ''
      this.filteredOptions = [] // Clear the suggestions
      this.optionSelected = {
        cp: '',
        claveEntidadFederativa: null,
        claveMunicipio: null,
        municipio: '',
        entidadFederativa: '',
        colonia: '',
        calle: '',
        numeroInterior: '',
        numeroExterior: '',
        entreCalle1: '',
        yCalle2: '',
        referenciasAdicionales: '',
        customSuburb: false,
      }
    },
    emitOption() {
      // Only for data outside the catalog
      if (this.customSuburb) {
        this.optionSelected.cp = this.searchQuery
      }
      const isValid = this.$refs.form.validate()
      if (isValid) {
        this.$emit('input', this.optionSelected)
      } else {
        this.$emit('input', null)
      }
    },
    async getCpData() {
      try {
        this.errorMessage = ''
        const cp = parseInt(this.searchQuery, 10)
        let query = this.$fire.firestore
          .collection('sepomex')
          .where('cp', '==', cp)

        if (this.obj.schema.region) {
          query = query.where(
            'claveEntidadFederativa',
            '==',
            parseInt(this.obj.schema.region)
          )
        }

        // Get the snapshot of the query results
        const querySnapshot = await query.get()

        if (querySnapshot.empty) {
          this.clearData()
          this.errorMessage = this.$t('procedures.noInfoTitle')
          return
        }

        // Loop through the documents in the snapshot
        this.filteredOptions = querySnapshot.docs.map((doc) => {
          const data = doc.data()
          return {
            ...data,
            colonia: this.obj.schema.onlyMayus
              ? data.colonia.toUpperCase()
              : data.colonia,
            entidadFederativa: this.obj.schema.onlyMayus
              ? data.entidadFederativa.toUpperCase()
              : data.entidadFederativa,
            municipio: this.obj.schema.onlyMayus
              ? data.municipio.toUpperCase()
              : data.municipio,
          }
        })

        if (this.optionSelected.colonia) {
          const matchedOption = this.filteredOptions.find(
            (opt) => opt.colonia === this.optionSelected.colonia
          )
          if (matchedOption) {
            // Hace un merge de los datos encontrados en optionSelected
            Object.assign(this.optionSelected, matchedOption)
          } else {
            // Si no encontró una coincidencia específica, selecciona la primera opción
            Object.assign(this.optionSelected, this.filteredOptions[0])
            this.emitOption()
          }
        } else {
          // Se selecciona la primera opción como default
          Object.assign(this.optionSelected, this.filteredOptions[0])
          this.emitOption()
        }
      } catch (error) {
        this.clearData()
        this.errorMessage = `${this.$t(
          'editor.an-error-has-occurred-please-try-again'
        )}: ${error}`
      }
    },
  },
}
